import { useState, useEffect } from "react";

type Props = {
  image: string[];
  subtitle: string[];
  cta?: string;
  ctaLink?: string;
  small?: boolean;
  logo: string;
};

const Hero: React.FC<Props> = ({
  image,
  subtitle = [],
  cta,
  ctaLink,
  logo,
  small = false,
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-slide functionality
  useEffect(() => {
    if (image.length <= 1) return;

    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % image.length);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [image.length, isHovered]);

  const handleDotClick = (index: number) => {
    setCurrentImageIndex(index);
  };

  return (
    <div
      className={`${
        small ? "h-[75vh]" : "h-[50vh] md:h-screen"
      } relative flex items-center justify-center shadow-2xl overflow-hidden`}
    >
      {/* Image slideshow */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="flex transition-transform duration-1000 ease-in-out h-full"
          style={{
            transform: `translateX(-${currentImageIndex * 100}vw)`,
          }}
        >
          {image.map((img, index) => (
            <div
              key={index}
              className="h-full bg-cover bg-center flex-shrink-0"
              style={{
                backgroundImage: `url(${img})`,
                width: `100vw`,
              }}
            />
          ))}
        </div>
      </div>

      {/* Content overlay */}
      <div className="relative z-10 flex items-center justify-center flex-col gap-5 md:gap-[25px] mt-20 md:mt-40">
        {/* <div>
          {subtitle.map((s, i) => (
            <div
              key={i}
              className="text-white text-center text-lg uppercase leading-6"
            >
              {s}
            </div>
          ))}
        </div> */}
        <img src={logo} alt="logo" className="w-[80vw] md:h-32 md:w-auto" />
        {!!cta && !!ctaLink && (
          <a
            href={ctaLink}
            className="text-white text-sm font-bold pt-2 md:text-md uppercase bg-blue py-1 px-10 shadow-md"
          >
            {cta}
          </a>
        )}
      </div>

      {/* Navigation dots */}
      {image.length > 1 && (
        <div
          className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-20"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {image.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === currentImageIndex
                  ? "bg-white scale-125"
                  : "bg-white/50 hover:bg-white/75"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Hero;
